import React from 'react';
import { KatIcon, KatButton } from '@amzn/katal-react';
import DiscussionPost from 'src/components/thread-detail/DiscussionPost';
import { threadDetailActions, selectSolutionPost } from 'src/redux/slices/threadDetailSlice';
import { useTranslation } from 'src/utils';
import { useRouter } from 'next/router';
import { useAppSelector, useAppDispatch } from 'src/redux/hooks';
import { getThreadDetail } from 'src/constants/pages';

const SolutionPostContainer: React.FC = () => {
  const { t } = useTranslation();
  const { query, push } = useRouter();
  const { threadId } = query as { threadId: string, postId: string };
  const dispatch = useAppDispatch();
  const solutionPost = useAppSelector(selectSolutionPost);
  if (solutionPost) {
    return (
      <div data-testid="solution-post" className="ltr:ml-[6.875rem] rtl:mr-[6.875rem]">
        <DiscussionPost
          postId={solutionPost.id}
          isShowRepliesVisible={false}
          postAction={(
            <KatButton
              variant="tertiary"
              onClick={() => {
                dispatch(threadDetailActions.setFocusedPostId(solutionPost.id));
                push(
                  {
                    pathname: getThreadDetail(threadId),
                    query: { postId: solutionPost.id },
                  },
                  undefined,
                  {
                    shallow: true,
                  },
                );
              }}
            >
              <KatIcon name="arrow_downward" size="small" />
              <span className="ltr:ml-1.5 rtl:mr-1.5">{t('viewSolutionLabel')}</span>
            </KatButton>
          )}
        />
      </div>
    );
  }
  return null;
};

export default SolutionPostContainer;
